import { Div } from "@tblabs/truffle";
import { Order } from "../../../../../../Models/Order";
import { TableEntry } from "./TableEntry";


export class PeopleList extends Div
{
    constructor(order: Order)
    {
        super();

        this.Append(
            ...order.People.Items.map(x => 
                new TableEntry({ Content: [x.AsString] }))
        );
    }
}
